import React, { createContext, useContext, useEffect, useState } from "react";
import capi, { saveConsumerAuth, clearConsumerAuth } from "../lib/consumerApi";

const Ctx = createContext(null);

export function ConsumerAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const embedToken = params.get("embed_token");
    if (embedToken) {
      capi.post("/embed/session", { embed_token: embedToken })
        .then((r) => {
          saveConsumerAuth(r.data);
          localStorage.setItem("lx_embed", "1");
          if (r.data.credits_balance != null) localStorage.setItem("lx_credits", String(r.data.credits_balance));
          setUser(r.data.user);
          params.delete("embed_token");
          const qs = params.toString();
          window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
        })
        .catch(() => { localStorage.removeItem("lx_embed"); setUser(false); });
      return;
    }
    const t = localStorage.getItem("lx_consumer_token");
    if (!t) { setUser(false); return; }
    capi.get("/consumer/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { setUser(false); localStorage.removeItem("lx_consumer_token"); });
  }, []);

  // Apply the Family Vault embed theme to <body> (obsidian bg + hidden scrollbars).
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tp = params.get("theme");
    if (tp) localStorage.setItem("lx_embed_theme", tp);
    if (localStorage.getItem("lx_embed") === "1") {
      const theme = localStorage.getItem("lx_embed_theme") === "light" ? "light" : "dark";
      document.body.classList.add("estate-embed-body");
      document.body.style.background = theme === "light" ? "#DFE3EF" : "#0B0B12";
    }
  }, [user]);

  const login = async (email, password, captcha, extra) => {
    const { data } = await capi.post("/consumer/auth/login", { email, password, ...(captcha || {}), ...(extra || {}) });
    saveConsumerAuth(data);
    const me = await capi.get("/consumer/auth/me");
    setUser(me.data);
    return me.data;
  };

  const register = async (name, email, password, captcha) => {
    const { data } = await capi.post("/consumer/auth/register", { name, email, password, ...(captcha || {}) });
    if (data && data.pending_approval) return data;
    saveConsumerAuth(data);
    const me = await capi.get("/consumer/auth/me");
    setUser(me.data);
    return me.data;
  };

  const refresh = async () => {
    const { data } = await capi.get("/consumer/auth/me");
    setUser(data);
    return data;
  };

  const logout = (to) => {
    const rt = localStorage.getItem("lx_consumer_refresh");
    capi.post("/consumer/auth/logout", { refresh_token: rt }).catch(() => {});
    clearConsumerAuth();
    setUser(false);
    const org = localStorage.getItem("lx_portal") === "org";
    localStorage.removeItem("lx_portal");
    try { sessionStorage.removeItem("lx_onb_collapsed"); } catch (e) { /* ignore */ }
    window.location.href = typeof to === "string" ? to : org ? "/organizations/login" : "/login";
  };

  return <Ctx.Provider value={{ user, login, register, refresh, logout }}>{children}</Ctx.Provider>;
}

export const useConsumer = () => useContext(Ctx);
